import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { EtapaKanbanStruct } from '@shared/services/structs/servico/etapa-kanban.struct';
import { AlertCardComponent } from '@shared/components/alert-card/alert-card.component';

export interface AutomacaoDaEtapa {
  nome: string;
  icone: string;
  isAtivo: boolean;
}

export interface EtapaKanbanOrdemServicoExcluirDialogData {
  etapa: EtapaKanbanStruct;
  qtdMovimentacoesApontando: number;
  automacoes: AutomacaoDaEtapa[];
}

export interface EtapaKanbanOrdemServicoExcluirDialogResult {
  confirm: boolean;
}

@Component({
  selector: 'app-etapa-kanban-ordem-servico-excluir-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, AlertCardComponent],
  templateUrl: './etapa-kanban-ordem-servico-excluir-dialog.component.html',
  styleUrl: './etapa-kanban-ordem-servico-excluir-dialog.component.css',
})
export class EtapaKanbanOrdemServicoExcluirDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<
      EtapaKanbanOrdemServicoExcluirDialogComponent,
      EtapaKanbanOrdemServicoExcluirDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: EtapaKanbanOrdemServicoExcluirDialogData
  ) {}

  public get impacto(): string {
    const qtd = this.data.qtdMovimentacoesApontando;
    const os = 'Ordens de serviço nesta etapa impedem a exclusão.';
    if (qtd === 0) return `${os} Nenhuma outra etapa tem esta como destino.`;
    return qtd === 1
      ? `${os} 1 movimentação permitida aponta para ela e será removida das outras etapas.`
      : `${os} ${qtd} movimentações permitidas apontam para ela e serão removidas das outras etapas.`;
  }

  public get tituloAutomacoes(): string {
    const qtd = this.data.automacoes.length;
    return qtd === 1
      ? '1 automação será alterada e desligada'
      : `${qtd} automações serão alteradas e desligadas`;
  }

  public confirmar(): void {
    this.dialogRef.close({ confirm: true });
  }

  public cancelar(): void {
    this.dialogRef.close({ confirm: false });
  }
}
